import { ContractType } from 'services/interfaces/contractType';
import { IContract } from 'shared/models/contract';

/**
 * Trecho do nome usado pelo backend para identificar tipos freemium
 * (ex.: "Freemium com restrição"). Comparado em lowercase.
 */
export const FREEMIUM_CONTRACT_TYPE_MATCH = 'freemium';

export function getContractTypeName(
  types: ContractType[],
  contractTypeId?: number,
): string {
  if (contractTypeId == null) return '';
  return types.find((t) => t.id === contractTypeId)?.name ?? '';
}

export function getFreemiumContractTypeIds(types: ContractType[]): Set<number> {
  return new Set(
    types
      .filter((t) =>
        t.name?.toLowerCase().includes(FREEMIUM_CONTRACT_TYPE_MATCH),
      )
      .map((t) => t.id),
  );
}

export function hasFreemiumContract(
  contracts: IContract[],
  freemiumTypeIds: Set<number>,
): boolean {
  if (!freemiumTypeIds.size) return false;

  return contracts.some(
    (c) =>
      !c.deleted_at &&
      c.status === 1 &&
      c.contract_type_id != null &&
      freemiumTypeIds.has(c.contract_type_id),
  );
}

export function isStandardMonthlyContractType(
  validityDurationUnit: 'day' | 'week' | 'month' | 'year',
  validityDurationValue: number,
  orderCycleDays: number,
): boolean {
  if (
    validityDurationUnit === 'month' &&
    validityDurationValue === 12 &&
    orderCycleDays === 30
  ) {
    return true;
  } else {
    return false;
  }
}

export function isStandardYearlyContractType(
  validityDurationUnit: 'day' | 'week' | 'month' | 'year',
  validityDurationValue: number,
  orderCycleDays: number,
): boolean {
  if (
    validityDurationUnit === 'month' &&
    validityDurationValue === 12 &&
    orderCycleDays === 365
  ) {
    return true;
  } else {
    return false;
  }
}
